export default __webpack_public_path__ + "static/media/refresh.b8e5392a.svg";